// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G1eb","newExpiryDate":"styles_newExpiryDate__34q_F","footer":"styles_footer__12tK-"};